export default __webpack_public_path__ + "static/media/failed.194b3be5.webp";